import * as React from "react";

import '../styles/App.css';
import '../styles/taskpane.css';
import '../styles/uicss.css';
import '../styles/Modal.css';
import '../styles/Layout.css';
import '../styles/Links.css';
import '../styles/Alerts.css';
import '../styles/Flex.css';

import Header from "./Header.jsx";
import HeroList from "./HeroList";
import Login from "./Login.jsx";
import ModeSelection from "./ModeSelection.jsx";
import MetamodelSelector from "./MetamodelSelector";
import ReportGenerator from "./ReportGenerator";
import Config from "../Config";
import GatewayCacheHandler from "../utils/GatewayCacheHandler";
import ModalMessage from "./modals/ModalMessage";
import RequestHelper from "../utils/RequestHelper";
import Commons from "../utils/Commons";
import { isDialog, ADOxxWindowRedirect, urlContain, checkOauthCredentials } from "./oauth/OAuth";
import Loader from "./Loader.jsx";
import Alert from "./Alert.jsx";
import AppCache from "../resources/data/AppCache.js";
import LicenseProvider from "./licenseManagement/LicenseProvider.jsx";

export default class App extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            appReady: false,
            showPopup: false,
            counting: {
                value: 0,
                isCounting: false
            },
            aModelData:
                {},
            filteredTech:
                {},
            aSplitedObjectReferences: [],
            nReRenderTrigger: 0,
            sSearchedValue: '',
            bLoaderVisibility: true,
            // bLoaderVisibility: false, // DEV
            listItems: [],
            isBasicAuth: true,
            userLogged: false,
            // userLogged: true, //DEV
            mode: 0,
            // mode: 1 // DEV
            loginError: {
                isOk: true,
                message: ""
            }
        };

        this.modalMessage = React.createRef();
        this.reportModalMessage = React.createRef();

        Config.getConfig();
    }

    async componentDidMount()
    {
        await AppCache();

        Config.getConfigEnv().then(() =>
        {

            if(!Config.env.WRC_OAUTH_ID){
                this.setState({
                    loginError: {
                        isOk: false,
                        message: Config.strings.messages.login.ErrorEnvID
                    }
                })
            }else{
                this.setState({
                    loginError: {
                        isOk: true,
                        message: ""
                    }
                })
            }

            Config.buildRequestUrls();
            if (Config.env)
            {
            this.setState({
                appReady: true
            });
            }
        });

        this.setState(
            {
                listItems: [
                    {
                        icon: "PlugConnected",
                        primaryText: Config.strings.welcomePage.items._1
                    },
                    {
                        icon: "ImageSearch",
                        primaryText: Config.strings.welcomePage.items._2
                    },
                    {
                        icon: "Design",
                        primaryText: Config.strings.welcomePage.items._3
                    },
                    {
                        icon: "DocumentApproval",
                        primaryText: Config.strings.welcomePage.items._4
                    }]
            });
    }

    handleSessionEnding = (nTimeToExpire, bSessionEnded) =>
    {
        if (bSessionEnded)
        {
            this.modalMessage.current.setMessage(Config.strings.messages.session.expired);
            localStorage.removeItem("user_name");
            this.modalMessage.current.setConfirmCallback(window.location.reload.bind(window.location));
        } else
        {
            const countingDown = async (callback, sMessage) =>
            {
                this.state.counting.isCounting = true;
                const fn = () =>
                {
                    if (this.state.counting.isCounting)
                    {
                        setTimeout(() =>
                        {
                            this.state.counting.value--;
                            callback(sMessage.replace(/%s/g, this.state.counting.value));
                            if (this.state.counting.value > 0)
                            {
                                fn();
                            } else
                            {
                                this.state.counting.isCounting = false;
                                return;
                            }
                        }, 1000);
                    }
                }
                fn();
            }
            this.modalMessage.current.setMessage(Config.strings.messages.session.noActivity.replace(/%s/g, nTimeToExpire));
            this.state.counting.value = nTimeToExpire;
            if (!this.state.counting.isCounting)
            {
                countingDown(this.modalMessage.current.setMessage, Config.strings.messages.session.noActivity);
            }
            this.modalMessage.current.setConfirmCallback(this.sessionEndingConfirmCallback);
        }
        this.modalMessage.current.openModal();
    }

    sessionEndingConfirmCallback = () =>
    {
        RequestHelper.sendRequestSimple({
            request: Commons.createGatewayRequestUrl({
                url: Config.anpRequestUrl.testAuth,
                endpoint: Config.requestSession
            }),
            dataType: "text",
        }).then((aData) =>
        {
            if (aData && "string" === typeof aData)
            {
                aData = JSON.parse(aData);
            }
            if (!aData.isErr && aData.hasOwnProperty("token") && aData.token && aData.hasOwnProperty("expire") && aData.expire)
            {
                localStorage["gateway_token"] = JSON.stringify(aData);
            } else
            {
                localStorage.removeItem("gateway_token");
                localStorage.removeItem("user_name");
            }
        }).catch((aEx) =>
        {
            console.error("Failed to retrieve end date of session");
        });
    }

    loginSuccess = () =>
    {
        let aGatewayCacheHandler = GatewayCacheHandler.getInstance();
        aGatewayCacheHandler.setExpirationTime(JSON.parse(localStorage["gateway_token"]).expire);
        aGatewayCacheHandler.startObserving(this.handleSessionEnding);

        Commons.getAdoVersion();

        if (this.state.isBasicAuth)
        {
            this.setState({ userLogged: true })
        }
    }

    modeSelected = (nModeSelected) =>
    {
        if (nModeSelected)
        {
            // this.state.bLoaderVisibility = false;
            this.setState({
                mode: nModeSelected,
                bLoaderVisibility: false
            });
        } else
        {
            this.setState({
                mode: 0,
                bLoaderVisibility: true
            });
        }
    }

    handleReportGenFailed = (sMessage) =>
    {
        if (this.reportModalMessage.current)
        {
            this.reportModalMessage.current.setMessage(sMessage, true);
            this.reportModalMessage.current.openModal();
        }
    }

    handleLoginMethod = () => {

        if(!this.state.appReady){
            return;
        }

        if(this.state.loginError.isOk){
            console.log('brak error')
        }else{
            console.log('error')
        }

        return (
            <div className="display-center">
                
                {
                this.state.loginError.isOk 
                    ? 
                    <Loader label={Config.strings.messages.login.redirect} labelDirection={"bottom"}/>
                    :
                    <Alert message={this.state.loginError.message} type={"danger"} />
                }
            </div>
        )
    }

    async componentDidUpdate() {

        if(urlContain("isDialog")){
            ADOxxWindowRedirect()
        } 
    }

    handleDialogView = () => {

        //view for the success login
        if(urlContain("code")){

            const url = window.location.href;
            const urlParams = new URLSearchParams(url.split("?")[1]);

            if (urlParams.has("code")) {

                const codeValue = urlParams.get("code");
                localStorage.setItem("SSO-ADOxx", codeValue);

                return Config.strings.messages.login.OAuthLoginSuccess;
            }
            return Config.strings.messages.login.OAuthLoginFailed;
        }

        //view for the failed login
        if(urlContain("error")){
            return Config.strings.messages.login.OAuthAccessDenied;
        }


        return this.handleLoginMethod();

    }

    handleDialogTemplate = () => {
        return(
            <div className="wrcDialog--conainer">
                <h1 className="wrcDialog--heading">{this.handleDialogView()}</h1>
            </div>
        );
    }

    render()
    {
        return (
            (isDialog(window.location.href) || urlContain("code") || urlContain("error")) ? 
            <>{this.handleDialogTemplate()}</>
            :
            <div>
                {
                    this.state.bLoaderVisibility ?

                        <span style={{ bLoaderVisibility: this.state.bLoaderVisibility }}>
                            <div className="ms-welcome">
                                <Header
                                    title={this.props.title}
                                    userLogged={this.state.userLogged}
                                />
                                <HeroList
                                    message={Config.strings.welcomePage.secondLabel}
                                    items={this.state.listItems}
                                />
                                {this.state.appReady ?
                                    <div>
                                        {this.state.isBasicAuth ?
                                            (
                                                this.state.userLogged ?
                                                    <LicenseProvider>
                                                        <ModeSelection
                                                            message={Config.strings.modeSelection.label}
                                                            isBasicAuth={this.state.isBasicAuth}
                                                            modeSetCallback={this.modeSelected}
                                                        />
                                                    </LicenseProvider>
                                                    :
                                                    <Login
                                                        message={Config.strings.login.label}
                                                        successCallback={this.loginSuccess}
                                                    />
                                            ) :
                                            <ModeSelection
                                                message={Config.strings.modeSelection.label}
                                                isBasicAuth={this.state.isBasicAuth}
                                                modeSetCallback={this.modeSelected}
                                            />
                                        }
                                    </div> :
                                    null
                                }
                            </div>
                        </span>

                        : (
                            (1 === this.state.mode) ?
                                <MetamodelSelector
                                    moveBackFn={this.modeSelected}
                                /> :
                                ((2 === this.state.mode) ?
                                    <ReportGenerator
                                        moveBackFn={this.modeSelected}
                                        failureCallback={this.handleReportGenFailed}
                                    /> :
                                    null)
                        )
                }
                <ModalMessage ref={this.reportModalMessage} />
                <ModalMessage ref={this.modalMessage} />
                {/* <RefreshTokenHelper /> */}
            </div>
        );
    }
}
